// extracted by mini-css-extract-plugin
export default {"triangle-heart":"moZEkcgGur5zNgYretku","img-div":"J8XFoUrsnZ4KiZ4DUtmF","type-default":"JWwL7KgGL10nDrLmh7U6","common_bganimation":"TJhLqFMvLhCOjOHmstYr"};